/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { selectEmbedToken, selectEmbedTokenExpiry } from 'modules/transactions/selectors';
import { transactionActions } from 'modules/transactions/slice';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrganizationId } from '../auth/selectors';
import TIME_OUTS from '../constants/time-outs';

const useUpdatePbiToken = () => {
  const dispatch = useDispatch();
  //
  const selectPbiTokenExpiry = useSelector(selectEmbedTokenExpiry);
  const organizationId = useSelector(selectOrganizationId);
  const embedToken = useSelector(selectEmbedToken)
  //
  const tryUpdateToken = useCallback(async () => {
    dispatch(transactionActions.getEmbedToken({ organizationId }));
  }, [organizationId]);
  //
  useEffect(() => {
    let interval;
    if (!embedToken.accessToken) {
      tryUpdateToken()
    }
    if (selectPbiTokenExpiry) {
      interval = setInterval(async () => {
        tryUpdateToken();
      }, new Date(selectPbiTokenExpiry).getTime() - (TIME_OUTS.P_B_TOKEN_REFRESH_TIME * 1000 + new Date().getTime()));
    }
    //
    return () => {
      clearInterval(interval);
    };
  }, [selectPbiTokenExpiry]);
};
//
export default useUpdatePbiToken;
